export default function isValidEmailAddress(text = '') {
  // use a rudimentary check, backend does the proper legwork
  // this is just to get the most obviously wrong cases out
  if (text.length > 255) {
    return false;
  }

  // regex copied from backend
  // eslint-disable-next-line no-useless-escape
  return /^([^@ \\,\(\),\:;\<\>\[\]]+)@([^\.@ ]+\.[^@ ]{2,})$/.test(text);
}
